import {useEffect, useRef, useState} from "react";
import "../assets/css/style.css"
import memberIcon from '../assets/img/member.png'
import logo from '../assets/img/logo.png'
import noMessage from '../assets/img/no-message.gif'
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {Link} from "react-router-dom";
import OtpInput from 'react-otp-input';
import axios from "axios";
import {toast, ToastContainer} from "react-toastify";
import {Comment, ProgressBar, ThreeDots} from "react-loader-spinner";
import Swal from 'sweetalert2'
import Dropdown from "react-bootstrap/Dropdown";
import iran from "../assets/img/iran.png";
import english from "../assets/img/english.png";

const ChatsEn = () => {

    const [height, setHeight] = useState(window.innerHeight);
    const [messages, setMessages] = useState([]);
    const [seller, setSeller] = useState('');
    const [name, setName] = useState('User');
    const [text, setText] = useState('');
    const [type, setType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [change, setChange] = useState(false);
    const [fileData, setFileData] = useState('');
    const myDivRef = useRef(null);
    const [isDisable, setIsDisable] = useState(false);

    const scrollToBottom = () => {
        if (myDivRef.current) {
            myDivRef.current.scrollTop = myDivRef.current.scrollHeight;
        }
    };

    const handleResize = () => {
        setHeight(window.innerHeight);
    };

    function toggle() {
        setModal(!modal)
    }


    function sendMessage(e) {
        e.preventDefault()
        setIsDisable(true)
        const data = new FormData();
        if (fileData !== ''  && text !== '') {
            data.append('text', text)
            data.append('file_data', fileData)
        }
        if (type === 'text') {
            data.append('text', text)
        }
        else {
            data.append('file_data', fileData)
        }
        axios.post('/send/message', data, {
            headers: {
                'Content-Type': "multipart/form-data"
            }
        })
            .then((res) => {
                setIsDisable(false)
                setText('')
                if (res.data.success) {
                    setChange(!change)
                    setIsDisable(false)
                    setModal(false)
                    setFileData(null)
                } else {
                    setChange(!change)
                    setFileData(null)
                    setIsDisable(false)
                    toast.error(res.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }
            })
            .catch((err) => {
                setIsDisable(false)
                setFileData(null)
                if (err.response.status === 422) {
                    let errors = [];
                    for (let error in err.response.data.errors)
                        err.response.data.errors[error].forEach((item) =>
                            errors.push(item)
                        );

                    errors.map((item, index) => {
                        toast.error(index + 1 + " - " + item, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });

                    })

                } else {
                    toast.error('خطا مجددا امتحان کنید', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }


            })
    }

    function getMessages() {
        axios.get('/conversation/messages')
            .then((res) => {
                if (res.data.success) {
                    setIsLoading(true)
                    setMessages(res?.data?.data?.messages)
                    setName(res?.data?.data?.user)
                    setSeller(res?.data?.data?.customer)
                    scrollToBottom();
                } else {
                    toast.error(res.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }
            })
            .catch((err) => {

                if (err.response.status === 422) {
                    let errors = [];
                    for (let error in err.response.data.errors)
                        err.response.data.errors[error].forEach((item) =>
                            errors.push(item)
                        );

                    errors.map((item, index) => {
                        toast.error(index + 1 + " - " + item, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        });

                    })

                } else {
                    toast.error('خطا مجددا امتحان کنید', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                }


            })
    }

    function logout() {
        Swal.fire({
            title: 'warning',
            text: 'Are you sure you want to log out of your account ?',
            icon: 'warning',
            confirmButtonText: 'yes',
            confirmButtonColor: 'success',
            showDenyButton: true,
            denyButtonText: `cancel`,
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(!isLoading)
                axios.delete('/logout')
                    .then((res) => {
                        if (res.data.success) {
                            window.localStorage.removeItem('token');
                            window.localStorage.removeItem('type');
                            window.location.replace('/')
                        } else {
                            toast.error(res.data.message, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "dark",
                            });
                        }
                    })
                    .catch((err) => {

                        if (err.response.status === 422) {
                            let errors = [];
                            for (let error in err.response.data.errors)
                                err.response.data.errors[error].forEach((item) =>
                                    errors.push(item)
                                );

                            errors.map((item, index) => {
                                toast.error(index + 1 + " - " + item, {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "dark",
                                });

                            })

                        } else {
                            toast.error('خطا مجددا امتحان کنید', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "dark",
                            });
                        }


                    })
            }
        });

    }

    useEffect(() => {
        document.title='Messages';
        window.addEventListener('resize', handleResize);
        getMessages()
        const interval = setInterval(getMessages, 30000);
        scrollToBottom()
        // Clean up the interval on component unmount
        return () => clearInterval(interval);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [change]);
    return (
        <>
            <div className={'container-fluid page-header'}>
                <Row className={'justify-content-between py-1 py-md-2'}>
                    <div className={"col-12 text-center "}>
                        <img src={logo} width={60} height={60} alt=""/>
                        <h3 style={{fontWeight: 800, fontFamily: 'IRANSans',marginTop:'0'}}>Rahat Bin</h3>
                    </div>
                </Row>
            </div>
            <Modal isOpen={modal} toggle={toggle} backdrop={false}>
                <ModalHeader toggle={toggle} className={'d-flex justify-content-between text-lg-end'}></ModalHeader>
                <ModalBody className={'p-0'} style={{height:"450px"}}>
                    <div className={'file-box text-center d-block justify-content-center'}>
                        <div className={'col-12'}>
                            <h3>Upload file</h3>
                        </div>
                        <div className={'row justify-content-center'}>
                            <div className={'col-12 col-md-6 col-lg-4  mt-5 '}>
                                <input type={"file"} className={'form-control'} name={'file'} id={'file'}
                                       onChange={(e) => {
                                           setFileData(e.target.files[0])
                                           setType('file')
                                       }}
                                />
                            </div>
                            <div className={'col-12  mt-5 '}>
                                <Label for={'text'}>Description </Label>
                                <textarea type={"file"} className={'form-control text-start'} name={'text'} id={'text'} rows={6} onChange={(e) => {setText(e.target.value)}}>{text}</textarea>
                            </div>
                        </div>
                        {isDisable &&
                            <div className={'row justify-content-center'}>
                                <div className={'col-12 col-md-6 col-lg-4  mt-5 '}>
                                    <ProgressBar
                                        height="80"
                                        width="80"
                                        ariaLabel="progress-bar-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="progress-bar-wrapper"
                                        borderColor = '#000'
                                        barColor = '#FFD02A'
                                    />
                                </div>
                            </div>
                        }



                    </div>

                </ModalBody>
                <ModalFooter className={'justify-content-center'}>

                    <Button color="danger" onClick={toggle}>cancel</Button>
                    <Button color="success" onClick={(e) => {
                    sendMessage(e)
                }} disabled={fileData === null || isDisable}>send</Button>{' '}
                </ModalFooter>
            </Modal>
            {modal && <div className="overlay" onClick={toggle}></div>}
            {/* Same as */}
            <ToastContainer/>
            <div className="container-fluid login-back" style={{height: height + 'px'}}>
                <div className="container login-back" style={{height: height + 'px'}}>
                    <Row className={'justify-content-center '}>
                        <div className={'col-12 col-md-10  chat-box'}>
                            <div className={'w-100 chat-header d-flex justify-content-between px-2'}>
                                <div className={'col-6  mt-1 mt-md-4 ps-3 pt-2 text-end d-xs-block d-md-flex justify-content-around'}
                                     style={{alignContent: 'center'}}>
                                    <Button color={'danger'} className={'px-4'} style={{height:'auto',maxHeight:"35px"}} onClick={(e) => {
                                        logout(e)
                                    }}><i
                                        className="fas fa-right-from-bracket"></i> Logout </Button>

                                        <Dropdown>
                                            <Dropdown.Toggle variant="warning"  align={{ lg: 'center' }} id="dropdown-basic" className={'px-3 mt-2 mt-md-0'}>
                                                Language
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item href="/" style={{direction:'rtl',textAlign:'left'}}>
                                                    فارسی <img src={iran} className={'ms-3'} width={30} height={20} alt=""/>
                                                </Dropdown.Item>
                                                <Dropdown.Item href="/en"  style={{direction:'rtl',textAlign:'left'}} >
                                                    English <img src={english} className={'ms-3'} width={30} height={20} alt=""/>
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                </div>
                                <div className={'col-6 text-center text-md-start '} id={'username'}>


                                    <img className={'bg-dark me-1 me-md-4 mt-1 mt-md-2 user-img'} style={{borderRadius: '50px'}}
                                                                                 src={memberIcon} alt=""/>
                                    <span style={{fontWeight: 800, fontSize: '20px'}} className={' me-3'}>{name}</span>
                                </div>

                            </div>
                            <div className={'chat-content text-end'} id={'chat-content'} ref={myDivRef}>
                                {!isLoading ?
                                    <Row className={'justify-content-center loader-gif'} style={{marginTop: '18%'}}>
                                        <Comment
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="comment-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="comment-wrapper"
                                            color="#000"
                                            backgroundColor="#FFD02A"
                                        />
                                    </Row>
                                    :
                                    messages.length > 0 ? messages.map((message) => (
                                            <>
                                                {message?.sender === 'member' ?
                                                    <Row className={'justify-content-end'}>
                                                        <div className={' message-box left  text-start'}><p>
                                                            {message?.type === '1' ? message?.text :
                                                                message?.type === '2' ?

                                                                    <>
                                                                    {message?.text}
                                                                        <br/>
                                                                        <br/>
                                                                        <a href={message.file} target={'_blank'}
                                                                           className={'btn btn-warning rounded-5 px-4'}
                                                                           download={'true'}>download <i
                                                                            className="fa-solid fa-download"></i></a>
                                                                        <span style={{direction:'rtl'}}> : Download file </span>
                                                                    </>
                                                                    :
                                                                <>

                                                                    <a href={message.file} target={'_blank'}
                                                                       className={'btn btn-warning rounded-5 px-4'}
                                                                       download={'true'}>download <i
                                                                        className="fa-solid fa-download"></i></a>
                                                                    <span style={{direction:'rtl'}}> : Download file </span>
                                                                </>

                                                            }

                                                        </p>
                                                            <div className={'message-date'}>you :{message?.created_at}</div>
                                                        </div>
                                                    </Row>
                                                    :
                                                    <Row className={'justify-content-start'}>
                                                        <div className={'message-box right  text-start'}><p>
                                                            {message?.type === '1' ? message?.text :
                                                                message?.type === '2' ?

                                                                    <>
                                                                        {message?.text}
                                                                        <br/>
                                                                        <br/>
                                                                        <a href={message.file} target={'_blank'}
                                                                           className={'btn btn-success rounded-5 px-4'}
                                                                           download={'true'}>download <i
                                                                            className="fa-solid fa-download"></i></a>
                                                                        <span style={{direction:'rtl'}}> : Download file </span>
                                                                    </>
                                                                    :
                                                                <>

                                                                    <a href={message.file} target={'_blank'}
                                                                       className={'btn btn-success rounded-5 px-4'}
                                                                       download={'true'}>download <i
                                                                        className="fa-solid fa-download"></i></a>

                                                                    <span> :  Download file</span>
                                                                </>

                                                            }
                                                        </p>
                                                            <div
                                                                className={'message-date'}>{seller} : {message?.created_at}</div>
                                                        </div>
                                                    </Row>
                                                }
                                            </>

                                        )) :
                                        <>
                                            <Row className={'justify-content-center no-message'} style={{marginTop: '10%'}}>
                                                <div className={'col-10 col-md-6 col-lg-3 '}>
                                                    <img src={noMessage} alt="" className={'w-100'}/>

                                                </div>
                                            </Row>
                                            <Row className={'justify-content-center  text-center'}>
                                                <span style={{fontWeight: 800, fontSize: '20px',direction:'ltr'}}
                                                      className={' me-3'}>Send your first message ....</span>
                                            </Row>
                                        </>


                                }


                            </div>
                            <div className={'w-100 chat-footer d-flex justify-content-around'}>


                                <div className={'col-2  mt-4 ps-5 pt-2 text-start'} style={{alignContent: 'center'}}>
                                    <Button style={{background: "#2799D8", border: 'none'}}
                                            disabled={text === '' || text === ' ' || text === '\t' || isDisable}
                                            onClick={(e) => {
                                                sendMessage(e)
                                                setIsDisable(true)
                                            }}
                                            className={'px-2 px-md-4 pt-2 send-btn'}>
                                        {isDisable ?
                                            <ThreeDots
                                                height="22px"
                                                width="50px"
                                                radius="9"
                                                color="#000"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{}}
                                                wrapperClassName=""
                                                visible={true}
                                            />  :
                                            <>
                                                <i className="fa-solid fa-paper-plane"></i><span> Send</span>
                                            </>

                                        }


                                    </Button>
                                </div>
                                <div className={'col-7 col-md-8  text-center pt-4 mt-1'}>
                                <FormGroup>
                                    <Input type="text" name="message" id="message" value={text}
                                           style={{fontWeight: 800, fontFamily: 'IRANSans',direction:'ltr'}} onChange={(e) => {
                                        setText(e.target.value)
                                        setType('text')
                                    }} placeholder="Enter your message ..."/>
                                </FormGroup>
                            </div>
                                <div className={'col-1 mt-4 ps-1  pe-sm-1 pe-lg-1 pt-2 text-end'} style={{alignContent: 'center'}}>
                                <i onClick={(e) => {
                                    setModal(true)
                                }} style={{fontSize: '35px', color: '#858E99', cursor: 'pointer'}}
                                   className={"fa-solid fa-paperclip  p-2"}></i>
                            </div>
                            </div>
                        </div>
                    </Row>

                </div>
            </div>

        </>
    )
}

export default ChatsEn;